import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPickupBatchProgress = {
  name: "getPickupBatchProgress" as const,
  input: z.object({ batchId: zExt.objectId() }),
  output: z.object({
    status: z.enum(["running", "done", "failed"]),
    processed: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
    errors: z.array(z.string()),
  }),
};
